var _style, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteIndLogoVert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 416",
    style: {
      enableBackground: "new 0 0 1000 416"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,330.9h21v80.7H5V330.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.6,380.4c-6-5.3-11.6-12.1-11.6-12.1s1.5,10.4,1.5,17v26.3H62.2v-81.8h1.7l37.3,32.2 c6.5,5.7,11.6,12.2,11.6,12.2s-1.2-10.5-1.2-17.2v-26.1h19.3v81.9h-1.7L91.6,380.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M166.7,330.9h29.1c23.8,0,42,15.5,42,40.3c0,24.6-18.1,40.3-42,40.3h-29.1V330.9z M194.7,393.4 c15,0,21.6-8.5,21.6-22.1c0-13.4-6.6-22.1-21.6-22.1h-7v44.2H194.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.2,379.8v-48.8h21v48.5c0,9.9,4.3,14.8,13.8,14.8c9.4,0,13.8-4.8,13.8-14.8v-48.5h21v48.8 c0,21.8-14.5,33.2-34.6,33.2C285.4,413,271.2,401.6,271.2,379.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M369.5,394.3l16.4-9.6c3.4,5.9,8.5,10.5,16.8,10.5c5.7,0,9.9-2.2,9.9-5.9c0-3.9-2.9-5.6-11-8.8l-3.4-1.4 c-13.3-5.4-22.3-11.9-22.3-26.3c0-14.1,10.8-23.3,26.4-23.3c11.6,0,19.6,3.4,26.3,13.9l-15.9,9.1c-2.8-4.5-5.7-5.7-9.7-5.7 c-4.2,0-7,2.2-7,5.7c0,4.3,3.6,5.9,8.3,7.9l3.4,1.4c14.8,6,25.7,12.1,25.7,27.4c0,15-11.4,23.8-30.5,23.8 C386.7,413,374.8,405.1,369.5,394.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M481.6,349.2h-22.9v-18.2h66.9v18.2h-22.9v62.4h-21.2V349.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M624,411.6h-23.6L589,392.1c-1.1,0.2-2.2,0.2-3.3,0.2h-6.3v19.3h-21v-80.7h27.4c21.3,0,36.9,9.6,36.9,30.9 c0,12.1-5.6,20.1-14.2,24.6L624,411.6z M585.3,374.5c11,0,15.9-3.6,15.9-12.7c0-9.1-4.9-12.8-15.9-12.8h-5.9v25.5H585.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M657.2,330.9h21v80.7h-21V330.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M712.4,371.3c0-24.7,19.8-41.7,43.4-41.7c23.7,0,43.4,17,43.4,41.7c0,24.4-19.8,41.7-43.4,41.7 C732.2,413,712.4,395.7,712.4,371.3z M777.8,371.3c0-13.6-9-23.2-22-23.2c-13,0-21.9,9.6-21.9,23.2c0,13.9,9,23.2,21.9,23.2 C768.8,394.4,777.8,385.2,777.8,371.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M832.7,379.8v-48.8h21v48.5c0,9.9,4.3,14.8,13.8,14.8c9.4,0,13.8-4.8,13.8-14.8v-48.5h21v48.8 c0,21.8-14.5,33.2-34.6,33.2C846.9,413,832.7,401.6,832.7,379.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M931,394.3l16.4-9.6c3.4,5.9,8.5,10.5,16.8,10.5c5.7,0,9.9-2.2,9.9-5.9c0-3.9-2.9-5.6-11-8.8l-3.4-1.4 c-13.3-5.4-22.3-11.9-22.3-26.3c0-14.1,10.8-23.3,26.4-23.3c11.6,0,19.6,3.4,26.3,13.9l-15.9,9.1c-2.8-4.5-5.7-5.7-9.7-5.7 c-4.2,0-7,2.2-7,5.7c0,4.3,3.6,5.9,8.3,7.9l3.4,1.4c14.8,6,25.7,12.1,25.7,27.4c0,15-11.4,23.8-30.4,23.8 C948.2,413,936.3,405.1,931,394.3z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M531.9,23.1l5.2-6.8c0.9-1.1,1.7-2.3,2.7-3.4c-1.1-2.6-2.1-5.2-4-8.5c-3.6-0.9-6.4-1.3-9.2-1.6 c-0.8,1.2-1.7,2.3-2.5,3.4l-5.2,6.9l-5.2,6.8l-2.4,3.1c5.6,0.7,11.1,2.7,16.1,6L531.9,23.1z M582.3,121.6 c-8-17.2-25.4-31.5-34.3-34.9c-1.4-36.5-22.8-50.2-43.7-50.2H500h-4.4c-20.9,0-42.3,13.7-43.7,50.2c-8.9,3.4-26.3,19-34.3,36.2 c-9.4,20.2-6.1,62.5-5.7,66.8l0.7,11.4h28.6c21,0,27.5-21,29.6-36.3c6.4,12.8,16.5,32.2,25.6,52l3.7,7.4l3.6-8.4 c9.1-19.8,19.1-38.1,25.5-50.9c2,15.3,8.5,36.1,29.5,36.1h28.6l0.7-12.1C588.5,184.8,591.7,141.8,582.3,121.6z M454.7,144.4 L454.7,144.4c0,23.1-4.1,36.1-13.5,36.1h-12.4c-0.6-14.4-0.3-37.1,4.7-48c3.8-8.2,9.8-17.6,14.9-22.5l4.1,23.4L454.7,144.4 C454.7,144.4,454.7,144.4,454.7,144.4z M495.7,55.1h4.4h4.3c12,0,24.1,6.2,26.7,28.8h-31H469C471.6,61.2,483.7,55.1,495.7,55.1z  M500,183.9c-4-9.6-9.4-17.7-13.3-26h26.6C509.4,166.1,504,174.3,500,183.9z M531.1,108.6c-0.8,6.2-2.2,18.5-3.4,24.7h-55.3 c-1.3-6.2-2.7-18.5-3.4-24.7 M571.1,180.5h-12.4c-9.4,0-13.5-13-13.5-36.1v0c0,0,0,0,0,0l2.2-11.5l4.2-23 c5.1,4.9,11,14.4,14.9,22.6C571.5,143.4,571.7,166.1,571.1,180.5z M468.1,23.1l4.5,5.9c5-3.2,10.5-5.2,16.1-6l-2.4-3.1l-5.2-6.8 l-5.2-6.9c-0.9-1.2-1.8-2.2-2.5-3.4c-2.8,0.3-5.6,0.7-9.2,1.6c-1.8,3.2-2.9,5.8-3.9,8.5c1,1,1.8,2.2,2.7,3.4L468.1,23.1z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteIndLogoVert);
export default __webpack_public_path__ + "static/media/WhiteIndLogoVert.7ec73bc183ca809c3568fec4e54fb015.svg";
export { ForwardRef as ReactComponent };